<template>
	<section
		class="page page-places"
		v-bind:class="{
			'has-scrolled': hasScrolled,
		}"
	>
		<ChalkyUiPageHero
			description="Thousands of verified spots to break and run."
			title="Find your Felt"
			v-bind:imageUrl="$asset('image/fpo/pagehero-00.jpg')"
		/>

		<ScenePlaces
			ref="scenePlaces"
			v-bind:favoriteVenueCollection="favoriteVenueCollection"
			v-bind:nearbyVenueCollection="nearbyVenueCollection"
			v-on:venue:select="Handle_OnSelectVenue"
		/>
	</section>
</template>

<script lang="ts">
	import * as Mixins from '@/Mixins';
	import ChalkySticks from '@chalkysticks/sdk';
	import PageBase from '@/Core/Page.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Places index page controller. Owns data collections, delegates
	 * presentation to ScenePlacesIndex, and handles navigation.
	 *
	 * We are INTENTIONALLY not tracking the user location on the page because
	 * subtle changes will end up refetching many pages. We have whatever
	 * location we had when walking in here.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component({
		mixins: [Mixins.AutoScroll, Mixins.StickyScroll],
	})
	export default class PagePlaces extends PageBase {
		/**
		 * Collection of user's favorite venues.
		 *
		 * @type ChalkySticks.Collection.Venue
		 */
		@Prop({
			default: () =>
				ChalkySticks.Factory.Venue.collection({
					limit: 8,
					qp: {
						reaction_from: 'me',
						reaction_type: ChalkySticks.Enum.ReactionType.Love,
					},
				}),
		})
		public favoriteVenueCollection!: ChalkySticks.Collection.Venue;

		/**
		 * Collection of nearby venues.
		 *
		 * @type ChalkySticks.Collection.Venue
		 */
		@Prop({
			default: () =>
				ChalkySticks.Factory.Venue.collection({
					limit: 12,
				}),
		})
		public nearbyVenueCollection!: ChalkySticks.Collection.Venue;

		/**
		 * Configuration for sticky behavior.
		 *
		 * @type IStickyScrollConfig
		 */
		protected stickyConfig: any = {
			scrollThreshold: 100,
		};

		/**
		 * Fetches next page of results via the Scene.
		 *
		 * @return Promise<void>
		 */
		protected async triggerLoadMore(): Promise<void> {
			await (this.$refs.scenePlaces as any).loadMore();
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Handle venue selection &mdash; navigate to venue detail page.
		 *
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectVenue(venueModel: ChalkySticks.Model.Venue): Promise<void> {
			this.$store.dispatch('gotoVenue', venueModel);
		}

		// endregion: Event Handlers
	}
</script>
